import { render } from "./sf-progress-percentage-numeric.vue?vue&type=template&id=632723c5"
import script from "./sf-progress-percentage-numeric.vue?vue&type=script&lang=js"
export * from "./sf-progress-percentage-numeric.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__